var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "user-check-01"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M8.49996 11.1428H5.52675C4.60468 11.1428 4.14365 11.1428 3.7685 11.2566C2.92384 11.5129 2.26285 12.1739 2.00662 13.0185C1.89282 13.3937 1.89282 13.8547 1.89282 14.7768M11.1428 12.7946L12.4643 14.1161L15.1071 11.4732M10.1518 5.85713C10.1518 7.49919 8.8206 8.83034 7.17854 8.83034C5.53648 8.83034 4.20532 7.49919 4.20532 5.85713C4.20532 4.21506 5.53648 2.88391 7.17854 2.88391C8.8206 2.88391 10.1518 4.21506 10.1518 5.85713Z",
    stroke: "#079455",
    strokeWidth: 1.32143,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserSuccess);
export default __webpack_public_path__ + "static/media/user-success.a7ea87c98e7910d7bf42fe59fcfa6779.svg";
export { ForwardRef as ReactComponent };